<template>
<v-card class="my-8" color="primary">
    <!-- Cute tiny form -->
    <div class="form">
        <label for="field-name" class="label">Name</label>
        <v-text-field v-model="name" placeholder="Type a name"></v-text-field>
    </div>

    <!-- Apollo watched Graphql query -->
    <ApolloQuery :query="require('../graphql/HelloWorld.gql')" :variables="{ name }">
        <template slot-scope="{ result: { loading, error, data } }">
            <!-- Loading -->
            <div v-if="loading" class="loading apollo">Loading...</div>

            <!-- Error -->
            <div v-else-if="error" class="error apollo">An error occured</div>

            <!-- Result -->
            <div v-else-if="data" class="result apollo">{{ data.hello }}</div>

            <!-- No result -->
            <div v-else class="no-result apollo">No result :(</div>
        </template>
    </ApolloQuery>

    <!-- Tchat example -->
    <ApolloQuery :query="require('../graphql/Messages.gql')">
        <ApolloSubscribeToMore :document="require('../graphql/MessageAdded.gql')" :update-query="onMessageAdded" />

        <v-content slot-scope="{ result: { data } }">
            <template v-if="data">
                <v-card v-for="message of data.messages" :key="message.id" color="accent" class="my-4">
                    {{ message.text }}
                </v-card>
            </template>
        </v-content>
    </ApolloQuery>

    <ApolloMutation :mutation="require('../graphql/AddMessage.gql')" :variables="{
        input: {
          text: newMessage,
        },
      }" class="form" @done="newMessage = ''">
        <template slot-scope="{ mutate }">
            <v-form v-on:submit.prevent="formValid && mutate()">
                <label for="field-message">Message</label>
                <v-text-field id="field-message" v-model="newMessage" placeholder="Type a message"></v-text-field>
            </v-form>
        </template>
    </ApolloMutation>

    <div>
        <div v-for="file of files" :key="file.id">
            <v-img :src="`${$filesRoot}/${file.path}`"  />
        </div>
    </div>

    <div>
        <label for="field-image">Image</label>
        <v-text-field color="accent" type="file" accept="image/*" required @change="onUploadImage"></v-text-field>
    </div>
</v-card>
</template>

<script>
import FILES from '../graphql/Files.gql'
import UPLOAD_FILE from '../graphql/UploadFile.gql'

export default {
    data() {
        return {
            name: 'Anne',
            newMessage: '',
        }
    },

    apollo: {
        files: FILES,
    },

    computed: {
        formValid() {
            return this.newMessage
        },
    },

    methods: {
        onMessageAdded(previousResult, {
            subscriptionData
        }) {
            return {
                messages: [
                    ...previousResult.messages,
                    subscriptionData.data.messageAdded,
                ],
            }
        },

        async onUploadImage({
            target
        }) {
            if (!target.validity.valid) return
            await this.$apollo.mutate({
                mutation: UPLOAD_FILE,
                variables: {
                    file: target.files[0],
                },
                update: (store, {
                    data: {
                        singleUpload
                    }
                }) => {
                    const data = store.readQuery({
                        query: FILES
                    })
                    data.files.push(singleUpload)
                    store.writeQuery({
                        query: FILES,
                        data
                    })
                },
            })
        }
    },
}
</script>
